import { useDispatch } from 'react-redux'
import { Route, Routes } from 'react-router-dom'

import { setLanguageList } from '@/app/slices/appSlice'
import { GenericErrorPage, NotFoundPage } from '@/common/components'
import UserRequiredContainer from '@/common/components/UserRequiredContainer/UserRequiredContainer'
import { Paths } from '@/common/utils'
import AccountSettings from '@/features/account-settings/AccountSettings'
import Documents from '@/features/documents/views/Documents'
import i18n from '@/i18n'

import Home from './features/home/Home'
import Logout from './features/logout/Logout'
import Order from './features/order/Order'
import OrderCheckout from './features/order-checkout/OrderCheckout'
import OrderConfirmation from './features/order-confirmation/OrderConfirmation'
import OrderHistory from './features/order-history/OrderHistory'
import OrderReview from './features/order-review/OrderReview'
import PartLibrary from './features/part-library/PartLibrary'
import PaymentSuccess from './features/payments/PaymentSuccess'

import './App.css'

const App = () => {
    const dispatch = useDispatch()

    i18n.services.backendConnector.backend.getLanguages((err, result) => {
        if (!err) {
            dispatch(setLanguageList(result))
        }
    })

    return (
        <Routes>
            <Route element={<UserRequiredContainer />}>
                <Route
                    element={<Home />}
                    path={`${Paths.HOME_PATHNAME}`}
                    index
                />
                <Route
                    element={<Order />}
                    path={`${Paths.ORDER_PATHNAME}`}
                />
                <Route
                    element={<OrderReview />}
                    path={Paths.ORDER_REVIEW_PATHNAME}
                />
                <Route
                    element={<OrderCheckout />}
                    path={Paths.ORDER_CHECKOUT_PATHNAME}
                />
                <Route
                    element={<OrderConfirmation />}
                    path={Paths.ORDER_CONFIRMATION_PATHNAME}
                />
                <Route
                    element={<PaymentSuccess />}
                    path={Paths.ORDER_PAYMENT_SUCCESS}
                />
                <Route
                    element={<OrderHistory />}
                    path={Paths.ORDER_HISTORY_PATHNAME}
                />
                <Route
                    element={<PartLibrary />}
                    path={Paths.PARTS_LIBRARY_PATHNAME}
                />
                <Route
                    element={<AccountSettings />}
                    path={Paths.ACCOUNT_PATHNAME}
                />
                <Route
                    element={<Documents />}
                    path={Paths.DOCUMENTS_PATHNAME}
                />
                <Route
                    element={<Logout />}
                    path={Paths.LOGOUT_PATHNAME}
                />
                <Route
                    element={<GenericErrorPage />}
                    path={Paths.ERROR_PATHNAME}
                />
                <Route
                    element={<NotFoundPage />}
                    path={Paths.NOT_FOUND}
                />
                <Route
                    element={<NotFoundPage />}
                    path="*"
                />
            </Route>
        </Routes>
    )
}

export default App
